import { getFromStorage } from '@libs/utils/helpers/handleStorage';
import { StorageMap } from '@common/constants/StorageMap';
import { useAuthentication } from '@libs/acp/contexts';
import { useTracking } from '../useTracking';
import { useEffect } from 'react';

export const useRenegFallback = () => {
  const { customer } = useAuthentication();
  const { elementViewedEvent } = useTracking();

  const isUnified = customer?.isUnified;
  const isRenegFallback = getFromStorage(StorageMap.RenegFallback) === 'true';

	useEffect(() => {
    if (isRenegFallback && !isUnified) {
      elementViewedEvent({
        name: 'Reneg Fallback',
        location: window.location.pathname,
      });
    }
  }, [isRenegFallback, isUnified]);

  return { isRenegFallback };
};
